<!-- <template>
  <div class="container">
    <div class="grid ">
      <div class="col-3">
        <Card class="centered" :style="{ width: '20vw' }">
          <template #title>
            <div class="grid">
              <div class="col-12 flex flex-wrap align-items-center justify-content-center">
                <img class="" src="../../../../assets/logo/logo1.png" style="width: 18vw;" />
              </div>
              <Divider />
              <div class="col-12 flex justify-content-center flex-wrap">
                 Hoşgeldiniz 
              </div>
            </div>
          </template>
          <template #content>
            <div class="grid">
              <div class="col-12">
                <InputGroup>
                  <InputGroupAddon>
                    <i class="pi pi-user"></i>
                  </InputGroupAddon>
                  <InputText id="kullaniciadi" placeholder="Kullanıcı Adı" v-model="username" autofocus  :invalid="this.Valid.username" />
                </InputGroup>
              </div>
              <div class="col-12">
                <InputGroup>
                  <InputGroupAddon>
                    <i class="pi pi-key"></i>
                  </InputGroupAddon>
                  <Password id="sifre" placeholder="Şifre" toggleMask v-model="password"  :feedback="false"  :invalid="this.Valid.password" />
                </InputGroup>
              </div>
              <div class="col-12">
                <Message size="small" severity="info" icon="pi pi-question-circle" style="cursor:pointer;" @click="this.SifremiUnuttum()">Şifremi unuttum</Message>
              </div>
              <div class="col-12 flex justify-content-center flex-wrap">
                <Button @click="this.handleClick()" label="Giriş" class="m-2" />
              </div>
            </div>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",

       //--------------
      // Validation Elements
      Valid: {
        password: false,
        username: false,
      }
    };
  },
  methods: {
    handleClick() {
      if (this._FormCheck()) { /* this.ResetForm(); */ return; }
        this.Login();
    },
    Login() {
      let user = {
        username: this.username,
        password: this.password,
        
      };
      this.$store.dispatch("auth/login", user).then(() => {
        // Role göre yönlendirme yapılmalı
        this.$router.push({ path: "/Admin/Main" });
      },
        (error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.$toast.add({
            severity: "warn",
            summary: "Giriş Hatası",
            detail: "Bilgiler hatalı",
            life: 3000,
          });
        }
      );
    },
    _FormCheck() {
      let Check = false;
      if (this.username === "") {
        this.Valid.username = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Kullanıcı adı girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.username = false; Check = false; }
       if (this.password === "") {
        this.Valid.password = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Şifre girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.password = false; Check = false; }
    },
    SifremiUnuttum(){
      
      this.$router.push({ path: "/SifreIslemleri/SifreUnuttum" });
    },
    resetForm() {
      this.username = "";
      this.password = "";
      this.submitted = false;
    },
  },
  components: {

  }
};
</script>
<style scoped>
.container {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: #cdd4cd;
}

.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
</style> -->






<template>
  <div class="login-container">
    <div class="login-card">
      <Card class="w-full">
        <template #title>
          <div class="flex flex-col items-center">
            <img src="../../../../assets/logo/logo1.png" class="w-32 mb-3 max-w-full" />
            <!-- <Divider class="w-full" /> -->
            <!-- <span class="text-lg font-medium">Hoşgeldiniz</span> -->
          </div>
        </template>

        <template #content>
          <div class="space-y-6">
            <InputGroup>
              <InputGroupAddon>
                <i class="pi pi-user"></i>
              </InputGroupAddon>
              <InputText
                id="kullaniciadi"
                placeholder="Kullanıcı Adı"
                v-model="username"
                autofocus
                :invalid="Valid.username"
              />
            </InputGroup>

            <InputGroup>
              <InputGroupAddon>
                <i class="pi pi-key"></i>
              </InputGroupAddon>
              <Password
                id="sifre"
                placeholder="Şifre"
                toggleMask
                v-model="password"
                :feedback="false"
                :invalid="Valid.password"
              />
            </InputGroup>

            <div class="text-right">
              <Message
                size="small"
                severity="info"
                icon="pi pi-question-circle"
                style="cursor: pointer"
                @click="SifremiUnuttum"
              >
                Şifremi unuttum
              </Message>
            </div>

            <div class="flex justify-center pt-2">
              <Button @click="handleClick" label="Giriş" class="w-full" />
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      Valid: {
        password: false,
        username: false,
      },
    };
  },
  methods: {
    handleClick() {
      if (this._FormCheck()) return;
      this.Login();
    },
    Login() {
      let user = {
        username: this.username,
        password: this.password,
      };
      this.$store.dispatch("auth/login", user).then(
        () => {
          this.$router.push({ path: "/Admin/Main" });
        },
        // eslint-disable-next-line 
        (error) => {
          this.$toast.add({
            severity: "warn",
            summary: "Giriş Hatası",
            detail: "Bilgiler hatalı",
            life: 3000,
          });
        }
      );
    },
    _FormCheck() {
      let Check = false;
      if (this.username === "") {
        this.Valid.username = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Kullanıcı adı girin", life: 3000 });
        return true;
      } else {
        this.Valid.username = false;
      }
      if (this.password === "") {
        this.Valid.password = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Şifre girin", life: 3000 });
        return true;
      } else {
        this.Valid.password = false;
      }
      return Check;
    },
    SifremiUnuttum() {
      this.$router.push({ path: "/SifreIslemleri/SifreUnuttum" });
    },
    resetForm() {
      this.username = "";
      this.password = "";
    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background-color: #cdd4cd;
  padding: 1rem;
}

.login-card {
  width: 100%;
  max-width: 400px;
}
</style>